<!--
  作者：顾先生
-->
<template>
  <div>
    <!--    头部主体-->
    <div class="headBox2 clearfix">
      <img src="../assets/img730/logo.png" class="logo">
      <div class="Show2" v-show="!ShowBox">
        <div class="Show2_font" @click="ShowBox = true">返回首页</div>
        <div class="show2_box1">公示信息仅作为企业在认证时点服务能力的客观证明，本公司不对其商业应用效果做出任何承诺或保证。</div>
        <div class="show2_box2 clearfix">
          <img src="../assets/img730/top.png" class="botm">
          <div class="titleBiaoTi">企业服务能力证书</div>
          <div class="show2_box2_font1"><span style="font-weight: bold">认证结果：</span>一级</div>
          <div class="show2_box2_font1"><span style="font-weight: bold">证书编号：</span>{{ info2.zs_zhengshu }}</div>
          <div class="show2_box2_font1"><span style="font-weight: bold">发证日期：</span>{{ info2.zs_riqi }}</div>
          <div class="show2_box2_font1"><span style="font-weight: bold">有效期至：</span>{{ info2.zs_qixian }}</div>
          <div class="show2_box2_font1"><span style="font-weight: bold">认证标准：</span>Q/130600JCXY003-2025</div>
          <div class="show2_box2_font1"><span style="font-weight: bold">认证机构：</span>河北鲸诚信用服务有限公司</div>
          <div class="titleBiaoTi2">企业基础信息</div>
          <div class="show2_box2_font1"><span style="font-weight: bold">公司名称：</span>{{ info2.zs_company_name }}</div>
          <div class="show2_box2_font1"><span style="font-weight: bold">法定代表人：</span>{{ info2.zs_company_idn }}</div>
          <div class="show2_box2_font1"><span style="font-weight: bold">所在行业：</span>{{ info2.zs_company_hangye }}</div>
          <div class="show2_box2_font1"><span style="font-weight: bold">注册地址：</span>{{ info2.zs_company_address }}</div>
          <div class="show2_box2_font5"><span style="font-weight: bold">经营范围：</span>{{ info2.zs_company_fanwei }}</div>
          <img src="../assets/img730/botm.png" class="bottomPo">
        </div>
      </div>
      <div class="Show1" v-show="ShowBox">
        <div class="box1">中小企业服务能力认证查询</div>
        <div class="box2">公示信息仅作为企业在认证时点服务能力的客观证明，本公司不对其商业应用效果做出任何承诺或保证。</div>
        <div class="box3">
          <el-input placeholder="请输入需要查询的企业名称" v-model="input3" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="chaxun">查询</el-button>
          </el-input>
        </div>
        <div class="box4" v-show="ShowBox2">
          <div class="show_font1" v-if="!showInfo">未查询到信息</div>
          <div class="show_fontBox" v-if="showInfo">
            <div class="font_1">公示结果</div>
            <div class="border1"></div>
            <div class="font_box">
<!--              {{ info1.zs_company_name }} {{ info1.zs_company_hangye }}-->
              <div class="font_box_span1">{{ info1.zs_company_name }}</div>
              <div class="font_box_span2">{{ info1.zs_company_hangye }}</div>
              <div class="font_box_span3" @click="chakan">查看详情</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="top">©版权所有：河北鲸诚信用服务有限公司</div>
        <div class="top">备案号：冀ICP备2024072650号-9 客服电话：400-056-5663</div>
<!--        <div class="btom">-->
<!--          <img src="../assets/img730/wangan.png" class="wangan">-->
<!--          <span>冀公网安备13060602001723</span>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { chakanCompany, SerchInfo, zhengshuChaKan } from '@/http/api/user'

export default {
  name: 'move',
  // 注册组件
  components: {},
  // 注册方法
  methods: {
    async chaxun() {
      if (this.input3.trim() === '') {
        this.input3 = ''
        return this.$message.error('请输入正确信息')
      }
      const data = await SerchInfo({
        title: this.input3
      })
      if (data.code === 1) {
        this.ShowBox2 = true
        this.showInfo = false
      } else {
        this.showInfo = true
        this.ShowBox2 = true
        this.info1 = data.data
      }
    },
    async chakan() {
      const data = await chakanCompany({
        zs_id: this.info1.zs_id
      })
      this.info2 = data.data
      this.ShowBox = false
    },
    async chakan222(idnum) {
      const data = await zhengshuChaKan({
        random: idnum
      })
      this.info2 = data.data
      this.ShowBox = false
    }
  },
  // 父子传值
  props: {},
  // 数据渲染
  data () {
    return {
      searchCompany: '',
      input3: '',
      showInfo: true,
      ShowBox: true,
      ShowBox2: false,
      info1: {},
      info2: {}
    }
  },
  // 计算属性
  computed: {},
  // 监听器
  watch: {},
  // 页面初次解析完成
  created () {
    const a = localStorage.getItem('zheng1')
    const b = localStorage.getItem('zheng2')
    if (a === 'JcxyR') {
      this.chakan222(b)
    }
  },
  // 页面内容渲染完成
  mounted () {}
}
</script>

<style scoped lang="less">
.Show2{
  .Show2_font{
    margin-right: 5vw;
    margin-top: -8.5vw;
    text-align: right;
    font-weight: 400;
    font-size: 3.6vw;
    color: #FFFFFF;
    &:hover{
      cursor: pointer;
    }
  }
  .show2_box1{
    width: 93vw;
    padding: 1vw 5vw;
    background-color: rgba(0,0,0,.36);
    margin: 10vw auto 0;
    font-weight: 400;
    font-size: 3.2vw;
    color: #FFFFFF;
    text-align: center;
    line-height: 6vw;
  }
  .show2_box2{
    position: relative;
    width: 95%;
    margin: 3vw auto 20vw;
    background: url("../assets/img730/guanwang.png");
    background-size: 100% 100%;
    padding-bottom: 20vw;
    .botm{
      display: block;
      margin: 12vw auto 0;
      width: 20vw;
    }
    .bottomPo{
      position: absolute;
      width: 25vw;
      bottom: 10vw;
      right: 10vw;
      z-index: 0;
    }
    .titleBiaoTi{
      text-align: center;
      font-size: 7vw;
      font-weight: bolder;
      color: #d91e23;
      margin-top: 4vw;
      margin-bottom: 4vw;
    }
    .titleBiaoTi2{
      text-align: center;
      font-size: 7vw;
      font-weight: bolder;
      color: #d91e23;
      margin-top: 6vw;
      margin-bottom: 4vw;
    }
    .show2_box2_font1,.show2_box2_font2,.show2_box2_font3,.show2_box2_font4,.show2_box2_font6,.show2_box2_font7,.show2_box2_font8{
      font-size: 3vw;
      margin-top: 2vw;
      margin-left: 10vw;
      width: 76vw;
      text-align: justify;
    }
    .show2_box2_font5{
      font-size: 3vw;
      margin-top: 2vw;
      margin-left: 10vw;
      width: 76vw;
      text-align: justify;
      line-height: 5vw;
      position: relative;
      z-index: 1;
    }
  }
}
.show_fontBox{
  padding-top: 5vw;
  .font_1{
    text-align: center;
    font-weight: bold;
    font-size: 6vw;
    color: #333333;
  }
  .border1{
    width: 100%;
    height: 1px;
    margin: 4vw auto 0;
    background: #E7E7E7;
  }
  .font_box{
    width: 88vw;
    margin: 4.5vw auto 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 3vw;
    .font_box_span1,.font_box_span2{
      white-space: nowrap; /* 禁止文本换行 */
      overflow: hidden; /* 隐藏溢出的内容 */
      text-overflow: ellipsis; /* 显示省略号 */
      color: #333333;
    }
    .font_box_span1{
      width: 36vw;
    }
    .font_box_span2{
      width: 34vw;
    }
    .font_box_span3{
      color: #F80000;
      &:hover{
        cursor: pointer;
      }
    }
  }
}
.box4{
  position: relative;
  width: 92vw;
  max-height: 90vw;
  background-color: #fff;
  margin: 4vw auto 15vw;
  border-radius: 3.5vw;
  padding: 1vw 0vw 7vw;
  overflow: auto;
  .show_font1{
    font-size: 5vw;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #666666;
  }
}
.bottom{
  position: absolute;
  bottom: 3vw;
  left: 50%;
  transform: translateX(-50%);
  .top{
    width: 92vw;
    text-align: center;
    font-size: 3.2vw;
    color: #FFFFFF;
  }
  .btom{
    margin-top: 2vw;
    font-size: 3.2vw;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .wangan{
    width: 5vw;
    margin-right: 1vw;
  }
}
.el-input {
  width: 100%;
}
.el-input-group{
  height: 12vw;
}
/deep/ .el-input__inner{
  height: 12vw;
}
/deep/ .el-input-group__append, .el-input-group__prepend {
  background-color: #F97A00;
  color: #FFFFFF;
  border: none;
}
.headBox2{
  position: relative;
  width: 100%;
  min-height: 100vh;
  background-image: url("../assets/img730/bgc.png");
  background-size: 100% 100%;
}
.logo{
  width: 55vw;
  margin-top: 5vw;
  margin-left: 3.7vw;
}
.box1{
  width: 90%;
  margin: 17vw auto 0;
  text-align: center;
  font-weight: bold;
  font-size: 12vw;
  color: #FFFFFF;
}
.box2{
  width: 90%;
  margin: 5vw auto 0;
  text-align: center;
  font-weight: 400;
  font-size: 3.7vw;
  color: #FFFFFF;
}
.box3{
  margin: 10vw auto 0;
  width: 92vw;
}
</style>
